import { render, staticRenderFns } from "./AIDiagnosis.vue?vue&type=template&id=153342b2&scoped=true&"
import script from "./AIDiagnosis.vue?vue&type=script&lang=js&"
export * from "./AIDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./AIDiagnosis.vue?vue&type=style&index=0&id=153342b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153342b2",
  null
  
)

export default component.exports